<script lang="ts" setup>
interface Props {
  columns?: number;
}

const props = withDefaults(defineProps<Props>(), {
  columns: 2,
});
</script>

<template>
  <div class="panel-grid">
    <div class="container-fluid">
      <div class="row gx-3 gy-3" :class="`row-cols-${props.columns}`">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
// Import Bootstrap mixins for responsive breakpoints
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.panel-grid {
  > .container-fluid {
    padding: $spacer;
    @include media-breakpoint-down(lg) {
      padding: 0;
    }

    // Direct child only: this collapses the top-level *panels* to one column on small
    // viewports. Must NOT use a descendant selector (`.container-fluid .row`) — that
    // leaks `width: 100%` into nested rows inside panels and clobbers their col-* widths.
    > .row {
      @include media-breakpoint-down(md) {
        @include row-cols(1);
      }
    }
  }
}
</style>
